module.exports = __webpack_public_path__ + "img/test2.8cd8d5e4.jpg";